export const AppointmentListPage = () => null;
